// extracted by mini-css-extract-plugin
export default {"main":"authLayout_main__vRT1e","header":"authLayout_header__p-EqY","icon":"authLayout_icon__L-bEt","iconText":"authLayout_iconText__BHVo+"};